module.exports = __webpack_public_path__ + "static/media/filter.58c2efd7.svg";